import { ArrowUpRight, FileChartColumn } from "lucide-react";
import type { JSX } from "react";

import type { ReportRef } from "@/lib/reports";

interface ReportCardProps {
  report: ReportRef;
  onOpen: (report: ReportRef) => void;
}

export function ReportCard({ report, onOpen }: ReportCardProps): JSX.Element {
  return (
    <div className="mt-4 overflow-hidden rounded-xl border border-border bg-card shadow-sm">
      <div className="h-1 bg-brand-extra-2-40" />
      <div className="flex items-center gap-3 p-4">
        <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-muted text-brand-extra-2-40">
          <FileChartColumn aria-hidden="true" size={20} />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-label-2 uppercase tracking-wider text-muted-foreground">
            Informe · v{report.revision_number}
            {report.status ? ` · ${report.status === "partial" ? "Parcial" : "Listo"}` : ""}
          </p>
          <p className="mt-0.5 truncate text-body-2 font-semibold text-foreground">
            {report.title}
          </p>
        </div>
        <button
          aria-label="Abrir informe"
          className="inline-flex shrink-0 items-center gap-1 rounded-md px-2 py-1.5 text-body-3 font-semibold text-brand-extra-2-40 hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          onClick={() => onOpen(report)}
          type="button"
        >
          Abrir <ArrowUpRight aria-hidden="true" size={15} />
        </button>
      </div>
    </div>
  );
}
